import React, { useState } from "react";
import { useGame } from "../context/GameContext";

const AVATARS = [
  { emoji: "🦊", bg: "#ff3e3e22", border: "#ff3e3e", text: "#ff3e3e" },
  { emoji: "👾", bg: "#9b6dff22", border: "#9b6dff", text: "#9b6dff" },
  { emoji: "🦖", bg: "#3effa322", border: "#3effa3", text: "#3effa3" },
  { emoji: "🐱", bg: "#f5c84222", border: "#f5c842", text: "#f5c842" },
  { emoji: "🦁", bg: "#ff6b3e22", border: "#ff6b3e", text: "#ff6b3e" },
  { emoji: "🐧", bg: "#3eaaff22", border: "#3eaaff", text: "#3eaaff" },
  { emoji: "🐷", bg: "#ff3eb522", border: "#ff3eb5", text: "#ff3eb5" },
  { emoji: "🐬", bg: "#3effee22", border: "#3effee", text: "#3effee" },
  { emoji: "👽", bg: "#aaff3e22", border: "#aaff3e", text: "#aaff3e" },
  { emoji: "👻", bg: "#ffffff22", border: "#ffffff", text: "#ffffff" },
];

/**
 * MEGA SENHA — Fluxo correto:
 * 1. REVEAL: Todos os Dadores veem a senha (em privado, um por vez)
 * 2. TURNO: Rodada intercalada — cada Dador dá 1 dica, depois os Adivinhadores do time tentam
 *    As dicas ficam visíveis para TODOS acumuladas
 *    Qualquer Adivinhador pode dar o palpite — não é isolado por dupla
 * 3. RESULTADO: quem acertou ganha o ponto, nova palavra ou encerrar
 */

// ── 1. Revelação da senha — cada Dador vê em privado ──────────
export function MegaSenhaRevealScreen() {
  const { megaSenhaPalavra, megaSenhaPares, jogadores, setFase } = useGame();
  const [dadoresViram, setDadoresViram] = useState([]);
  const [dadoresVendo, setDadoresVendo] = useState(null);

  const dadores = megaSenhaPares.map(p => p.dador);
  const todoViram = dadores.every(i => dadoresViram.includes(i));

  if (dadoresVendo !== null) {
    const av = AVATARS[dadoresVendo % AVATARS.length];
    const par = megaSenhaPares.find(p => p.dador === dadoresVendo);
    const nomeAdiv = par ? jogadores[par.adivinhador] : "";
    return (
      <div className="app-wrapper" style={{ paddingTop: 80 }}>
        <div className="card" style={{ maxWidth: 460 }}>
          <div className="card-header">
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 12 }}>
              <div style={{ width: 48, height: 48, borderRadius: "50%", background: av.bg, border: `2px solid ${av.border}`, color: av.text, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.6rem" }}>{av.emoji}</div>
              <div>
                <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.4rem" }}>{jogadores[dadoresVendo]}</div>
                <div style={{ color: "var(--text-muted)", fontSize: "0.75rem" }}>Dador de Dicas</div>
              </div>
            </div>
            <h2 className="title-main" style={{ fontSize: "1.6rem" }}>A senha secreta</h2>
          </div>
          <div className="card-body" style={{ textAlign: "center" }}>
            <div style={{ fontSize: "2.8rem", fontFamily: "'Bebas Neue'", color: "#ff6b3e", letterSpacing: "0.08em", padding: "20px", background: "#ff6b3e15", borderRadius: 14, border: "1px solid #ff6b3e40" }}>
              {megaSenhaPalavra}
            </div>
            <div style={{ marginTop: 16, padding: 14, background: "var(--bg-elevated)", borderRadius: 10, fontSize: "0.82rem", color: "var(--text-secondary)", lineHeight: 1.5 }}>
              💡 Você vai dar <strong style={{ color: "var(--text-primary)" }}>1 palavra por turno</strong> como dica.
              Seu parceiro <strong style={{ color: av.text }}>{nomeAdiv}</strong> e os outros Adivinhadores vão tentar adivinhar a senha!
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-primary btn-full" onClick={() => {
              setDadoresViram(prev => [...prev, dadoresVendo]);
              setDadoresVendo(null);
            }}>✅ Memorizei</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-wrapper" style={{ paddingTop: 80 }}>
      <div className="card" style={{ maxWidth: 500 }}>
        <div className="card-header">
          <div className="title-eyebrow">🏆 Mega Senha · Revelação</div>
          <h2 className="title-main" style={{ fontSize: "1.8rem" }}>Dadores,<br /><span style={{ color: "#ff6b3e" }}>vejam a senha!</span></h2>
          <p className="title-sub">Cada Dador de Dicas vê a senha em privado. Os Adivinhadores não podem olhar!</p>
        </div>
        <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ background: "#ff6b3e15", border: "1px solid #ff6b3e40", borderRadius: 14, padding: "20px", textAlign: "center" }}>
            <div style={{ fontSize: "0.72rem", color: "#ff6b3e", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>🔐 A senha desta rodada</div>
            <div style={{ fontSize: "2.6rem", fontFamily: "'Bebas Neue'", color: "#ff6b3e", filter: todoViram ? "none" : "blur(12px)", transition: "filter 0.3s", letterSpacing: "0.08em" }}>
              {megaSenhaPalavra}
            </div>
            {!todoViram && <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginTop: 6 }}>Visível após todos os Dadores confirmarem</div>}
          </div>

          {megaSenhaPares.map((par, i) => {
            const avD = AVATARS[par.dador % AVATARS.length];
            const avA = AVATARS[par.adivinhador % AVATARS.length];
            const viu = dadoresViram.includes(par.dador);
            return (
              <div key={i} style={{ background: "var(--bg-elevated)", borderRadius: 14, padding: "14px 16px", border: `2px solid ${viu ? "var(--green)" : "var(--border)"}` }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                  <div style={{ background: "rgba(255,107,62,0.15)", border: "1px solid #ff6b3e", color: "#ff6b3e", borderRadius: 8, padding: "2px 10px", fontSize: "0.72rem", fontFamily: "'Space Mono'" }}>
                    DUPLA {i + 1}
                  </div>
                  {viu && <span style={{ color: "var(--green)", fontSize: "0.78rem" }}>✅ Viu</span>}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "0.7rem", color: "var(--text-muted)", marginBottom: 4 }}>🎙️ Dador</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: "1.3rem" }}>{avD.emoji}</span>
                      <span style={{ fontWeight: 700, color: avD.text }}>{jogadores[par.dador]}</span>
                    </div>
                  </div>
                  <span style={{ color: "var(--text-muted)" }}>↔️</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "0.7rem", color: "var(--text-muted)", marginBottom: 4 }}>🎯 Adivinhador</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: "1.3rem" }}>{avA.emoji}</span>
                      <span style={{ fontWeight: 700, color: avA.text }}>{jogadores[par.adivinhador]}</span>
                    </div>
                  </div>
                  {!viu && (
                    <button onClick={() => setDadoresVendo(par.dador)} style={{
                      background: "rgba(255,107,62,0.15)", border: "1px solid #ff6b3e", color: "#ff6b3e",
                      borderRadius: 10, padding: "8px 14px", cursor: "pointer", fontSize: "0.8rem", fontWeight: 700, whiteSpace: "nowrap",
                    }}>👁️ Ver senha</button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="card-footer">
          <button className="btn btn-primary btn-full" disabled={!todoViram} onClick={() => setFase("MEGASENHA_TURNO")}>
            🏆 Todos viram — iniciar turnos →
          </button>
        </div>
      </div>
    </div>
  );
}

// ── 2. Turnos intercalados — todos jogam juntos ────────────────
export function MegaSenhaTurnoScreen() {
  const { megaSenhaPares, megaSenhaParIdx, megaSenhaDicas, jogadores, megaSenhaAdicionarDicaEAvancar, megaSenhaAcertouFn } = useGame();
  const [dica, setDica] = useState("");
  const [erro, setErro] = useState("");
  const [mostrarPalpite, setMostrarPalpite] = useState(false);

  const par = megaSenhaPares[megaSenhaParIdx];
  if (!par) return null;
  const nomeDador = jogadores[par.dador];
  const nomeAdiv = jogadores[par.adivinhador];
  const avD = AVATARS[par.dador % AVATARS.length];
  const avA = AVATARS[par.adivinhador % AVATARS.length];

  const confirmarDica = () => {
    if (!dica.trim()) { setErro("Digite uma dica!"); return; }
    if (dica.trim().split(/\s+/).length > 1) { setErro("Apenas UMA palavra por dica!"); return; }
    megaSenhaAdicionarDicaEAvancar(dica.trim());
    setDica(""); setErro("");
    setMostrarPalpite(true);
  };

  return (
    <div className="app-wrapper" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <div className="card" style={{ maxWidth: 540 }}>
        <div className="card-header">
          <div className="title-eyebrow">🏆 Mega Senha · Turno {megaSenhaDicas.length + 1}</div>
          <p className="title-sub" style={{ marginTop: 8 }}>
            Todos os Adivinhadores podem tentar a cada turno usando as dicas acumuladas.
          </p>
        </div>

        <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {/* Dicas acumuladas */}
          {megaSenhaDicas.length > 0 && (
            <div style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: "14px 16px" }}>
              <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 10 }}>
                💬 Dicas acumuladas ({megaSenhaDicas.length})
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {megaSenhaDicas.map((d, i) => {
                  const pDador = megaSenhaPares[d.parIdx];
                  const av = pDador ? AVATARS[pDador.dador % AVATARS.length] : AVATARS[0];
                  return (
                    <span key={i} style={{ background: av.bg, border: `1px solid ${av.border}`, color: av.text, borderRadius: 20, padding: "5px 14px", fontSize: "0.88rem", fontWeight: 700 }}>
                      {d.dica}
                      <span style={{ fontSize: "0.65rem", opacity: 0.7, marginLeft: 6 }}>{jogadores[pDador?.dador]?.split(" ")[0]}</span>
                    </span>
                  );
                })}
              </div>
            </div>
          )}

          {/* Dador atual */}
          <div style={{ background: "#ff6b3e15", border: "2px solid #ff6b3e", borderRadius: 14, padding: "16px" }}>
            <div style={{ fontSize: "0.72rem", color: "#ff6b3e", textTransform: "uppercase", fontWeight: 700, marginBottom: 10 }}>
              🎙️ Vez de dar dica
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: avD.bg, border: `2px solid ${avD.border}`, color: avD.text, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.4rem" }}>{avD.emoji}</div>
              <div>
                <div style={{ fontWeight: 700, color: avD.text }}>{nomeDador}</div>
                <div style={{ fontSize: "0.72rem", color: "var(--text-muted)" }}>Dador de Dicas</div>
              </div>
            </div>
            <div className="input-group" style={{ marginBottom: 0 }}>
              <label className="input-label" style={{ color: "#ff6b3e" }}>{nomeDador}: sua dica (1 palavra)</label>
              <input className="input-field" placeholder="Ex: quente, doce, italiano..." value={dica}
                onChange={e => { setDica(e.target.value); setErro(""); }}
                onKeyDown={e => { if (e.key === "Enter") confirmarDica(); }} autoFocus />
              {erro && <div style={{ color: "var(--accent)", fontSize: "0.8rem", marginTop: 6 }}>⚠️ {erro}</div>}
            </div>
          </div>

          {/* Adivinhadores desta dupla */}
          <div style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: "14px 16px" }}>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 10 }}>
              🎯 Adivinhadores — podem tentar após a dica
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {megaSenhaPares.map((p, i) => {
                const avA2 = AVATARS[p.adivinhador % AVATARS.length];
                return (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, background: avA2.bg, border: `1px solid ${avA2.border}`, borderRadius: 20, padding: "5px 12px" }}>
                    <span style={{ fontSize: "1rem" }}>{avA2.emoji}</span>
                    <span style={{ fontSize: "0.82rem", fontWeight: 700, color: avA2.text }}>{jogadores[p.adivinhador]}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="card-footer" style={{ flexDirection: "column", gap: 10 }}>
          <button className="btn btn-primary btn-full" onClick={confirmarDica}>
            ➡️ Dar dica e abrir palpite
          </button>
          <button className="btn" style={{ background: "rgba(62,255,163,0.15)", border: "1px solid var(--green)", color: "var(--green)", width: "100%" }} onClick={megaSenhaAcertouFn}>
            🎉 Alguém acertou a senha!
          </button>
        </div>
      </div>

      {/* Modal de palpite pós-dica */}
      {mostrarPalpite && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "16px 16px calc(env(safe-area-inset-bottom, 0px) + 16px)" }}
          onClick={() => setMostrarPalpite(false)}>
          <div style={{ background: "var(--bg-card)", borderRadius: 20, padding: 28, maxWidth: 400, width: "100%", border: "1px solid var(--green)" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: "2.5rem", marginBottom: 8 }}>🎯</div>
              <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.6rem", color: "var(--green)" }}>Alguém acertou?</div>
              <div style={{ color: "var(--text-secondary)", fontSize: "0.85rem", marginTop: 6 }}>
                Com base nas dicas acumuladas, algum Adivinhador sabe a senha?
              </div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => setMostrarPalpite(false)}>
                ❌ Não acertou
              </button>
              <button className="btn" style={{ flex: 1, background: "var(--green)", color: "#0a0a0f", border: "none" }} onClick={() => { setMostrarPalpite(false); megaSenhaAcertouFn(); }}>
                ✅ Acertou!
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── 3. Resultado da palavra ────────────────────────────────────
export function MegaSenhaResultadoScreen() {
  const { megaSenhaPalavra, megaSenhaPares, megaSenhaAcertou, megaSenhaDicas, jogadores, megaSenhaProximaRodada, megaSenhaFinalizar, megaSenhaRodadas } = useGame();
  const parVencedor = megaSenhaAcertou !== null ? megaSenhaPares[megaSenhaAcertou] : null;
  const avA = parVencedor ? AVATARS[parVencedor.adivinhador % AVATARS.length] : null;

  // Placar de rodadas ganhas
  const pontos = {};
  megaSenhaRodadas.forEach(r => {
    if (r.vencedor !== null && r.vencedor !== undefined) {
      pontos[r.vencedor] = (pontos[r.vencedor] || 0) + 1;
    }
  });

  return (
    <div className="app-wrapper" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <div className="card" style={{ maxWidth: 500 }}>
        <div className="card-header" style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3.5rem", marginBottom: 12 }}>{parVencedor ? "🏆" : "⏰"}</div>
          <h2 className="title-main" style={{ fontSize: "2rem", color: parVencedor ? "#ff6b3e" : "var(--text-secondary)" }}>
            {parVencedor ? `${jogadores[parVencedor.adivinhador]} acertou!` : "Ninguém acertou!"}
          </h2>
          <div style={{ background: "#ff6b3e15", border: "1px solid #ff6b3e40", borderRadius: 12, padding: "14px 18px", marginTop: 14 }}>
            <div style={{ fontSize: "0.72rem", color: "#ff6b3e", textTransform: "uppercase", marginBottom: 6 }}>🔐 A senha era</div>
            <div style={{ fontFamily: "'Bebas Neue'", fontSize: "2.2rem", color: "#ff6b3e" }}>{megaSenhaPalavra}</div>
          </div>
        </div>
        <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {/* Dicas usadas */}
          <div style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: "14px 16px" }}>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 10 }}>💬 Dicas desta palavra</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {megaSenhaDicas.map((d, i) => {
                const p = megaSenhaPares[d.parIdx];
                const avD = p ? AVATARS[p.dador % AVATARS.length] : AVATARS[0];
                return (
                  <span key={i} style={{ background: avD.bg, border: `1px solid ${avD.border}`, color: avD.text, borderRadius: 20, padding: "4px 12px", fontSize: "0.82rem", fontWeight: 700 }}>
                    {d.dica}
                  </span>
                );
              })}
            </div>
          </div>

          {/* Placar acumulado de duplas */}
          {megaSenhaRodadas.length > 0 && (
            <div style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: "14px 16px" }}>
              <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 10 }}>🏆 Placar de duplas</div>
              {megaSenhaPares.map((p, i) => {
                const avA2 = AVATARS[p.adivinhador % AVATARS.length];
                const pts = pontos[i] || 0;
                return (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
                    <span style={{ fontSize: "1.1rem" }}>{avA2.emoji}</span>
                    <span style={{ flex: 1, fontSize: "0.88rem", fontWeight: 700, color: avA2.text }}>{jogadores[p.adivinhador]}</span>
                    <span style={{ fontFamily: "'Bebas Neue'", fontSize: "1.3rem", color: pts > 0 ? "#ff6b3e" : "var(--text-muted)" }}>{pts} pt{pts !== 1 ? "s" : ""}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="card-footer" style={{ gap: 10 }}>
          <button className="btn btn-secondary" onClick={megaSenhaFinalizar}>🏠 Ver placar final</button>
          <button className="btn btn-primary" onClick={megaSenhaProximaRodada}>🔄 Nova palavra →</button>
        </div>
      </div>
    </div>
  );
}
